export const appVersion = {
  version: "2.4.0",
  buildKey: "-",
  buildTime: "-",
};
